module.exports = __webpack_public_path__ + "08_hair_silver.fca4e6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/08_hair_silver.png
// module id = orCa
// module chunks = 0